import React from 'react';

//Estilos
import './Spinner.css';

function Spinner() {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    );
}

export default Spinner;
